import { gql } from 'graphql-tag';

const SIDEBAR_MARKET_LOCATION_FIELDS_FRAGMENT = gql`
  fragment SidebarMarketLocationFields on MarketLocation {
    id
    type
    name
    externalName
    contractPartner
    technologies
    marketingStart
    marketingEnd
    permissions {
      seeForecast
      editForecast
      seeRevenue
    }
  }
`;

const LINKED_SIDEBAR_MARKET_LOCATION_FIELDS_FRAGMENT = gql`
  fragment LinkedSidebarMarketLocationFields on MarketLocation {
    ...SidebarMarketLocationFields
    linkedMarketLocation {
      ...SidebarMarketLocationFields
    }
  }
  ${SIDEBAR_MARKET_LOCATION_FIELDS_FRAGMENT}
`;

export const SIDEBAR_MARKET_LOCATIONS_QUERY = gql`
  query SidebarMarketLocations($first: Int, $last: Int, $before: String, $after: String) {
    marketLocations(first: $first, last: $last, before: $before, after: $after) {
      totalCount
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        cursor
        node {
          ...LinkedSidebarMarketLocationFields
        }
      }
    }
  }
  ${LINKED_SIDEBAR_MARKET_LOCATION_FIELDS_FRAGMENT}
`;
